export default __webpack_public_path__ + "static/media/l_wdt_c_5.d2c75974.mp3";